'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assert = require('assert');

var _assert2 = _interopRequireDefault(_assert);

var _map = require('core-js/library/es6/map');

var _map2 = _interopRequireDefault(_map);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventHandlers = function () {
  function EventHandlers() {
    _classCallCheck(this, EventHandlers);

    this.handlers = new _map2.default();
  }

  _createClass(EventHandlers, [{
    key: 'get',
    value: function get(event) {
      return this.handlers.get(event);
    }
  }, {
    key: 'add',
    value: function add(event, handler) {
      var handlers = this.handlers.get(event);

      if (!handlers) {
        handlers = new Set();
      }

      handlers.add(handler);

      this.handlers.set(event, handlers);
    }
  }, {
    key: 'remove',
    value: function remove(event, handler) {
      var handlers = this.handlers.get(event);

      if (!handlers) {
        return;
      }

      handlers.delete(handler);

      this.handlers.set(event, handlers);
    }
  }]);

  return EventHandlers;
}();

var PendingCall = function PendingCall() {
  var _this = this;

  _classCallCheck(this, PendingCall);

  this.promise = new Promise(function (res, rej) {
    _this.resolve = res;
    _this.reject = rej;
  });
};

var WebviewComms = function () {
  function WebviewComms() {
    var _this2 = this;

    _classCallCheck(this, WebviewComms);

    this.currentId = 0;
    this.eventHandlers = new EventHandlers();
    this.isReady = false;
    this.pendingCalls = new _map2.default();

    this.call = function (_ref) {
      var event = _ref.event,
          _ref$data = _ref.data,
          data = _ref$data === undefined ? {} : _ref$data;

      _assert2.default.equal(typeof event === 'undefined' ? 'undefined' : _typeof(event), 'string', 'event must be a string');
      _assert2.default.equal(typeof data === 'undefined' ? 'undefined' : _typeof(data), 'object', 'data must be an object');

      var id = _this2.nextId();
      var msgObj = {
        id: id,
        event: event,
        data: data
      };

      // Call in next event loop
      setImmediate(function () {
        return _this2.postMessage(msgObj);
      });

      var pendingCall = new PendingCall();
      _this2.pendingCalls.set(id, pendingCall);

      return pendingCall.promise;
    };

    this.reply = function (_ref2) {
      var id = _ref2.id,
          data = _ref2.data;

      if (!_this2.pendingCalls.has(id)) {
        console.error('Nothing found for id: ' + id);
        return;
      }

      var promise = _this2.pendingCalls.get(id);
      _this2.pendingCalls.delete(id);

      // Protect against data being null
      data = data || {};

      if (data.error) {
        promise.reject(data);
        return;
      }

      promise.resolve(data);
    };

    this.notify = function (_ref3) {
      var event = _ref3.event,
          _ref3$data = _ref3.data,
          data = _ref3$data === undefined ? {} : _ref3$data;

      var handlers = _this2.eventHandlers.get(event);

      if (!handlers || !handlers.size) {
        return;
      }

      handlers.forEach(function (handler) {
        return handler(data);
      });
    };

    this.on = function (event, handler) {
      _this2.eventHandlers.add(event, handler);

      // Handle case where we are already ready
      if (event === 'ready' && _this2.isReady) {
        setImmediate(handler);
      }
    };

    this.once = function (event, handler) {
      var wrapper = function wrapper(data, event) {
        _this2.off(event, wrapper);
        handler(data);
      };
      _this2.on(event, wrapper);
    };

    this.off = function (event, handler) {
      _this2.eventHandlers.remove(event, handler);
    };

    // Create call helpers
    ['GET', 'LAUNCH', 'NAVIGATE', 'TRIGGER'].forEach(function (name) {
      _this2[name.toLowerCase()] = function (resource, data) {
        return _this2.call({ event: name + ':' + resource, data: data });
      };
    });

    // Create event helpers
    ['LOAD', 'NOTIFY'].forEach(function (name) {
      var firstUpper = name[0] + name.substr(1).toLowerCase();
      ['on', 'off', 'once'].forEach(function (type) {
        _this2['' + type + firstUpper] = function (resource, handler) {
          return _this2[type](name + ':' + resource, handler);
        };
      });
    });
  }

  _createClass(WebviewComms, [{
    key: 'setPostMessage',
    value: function setPostMessage(postMessage) {
      (0, _assert2.default)(typeof postMessage === 'function', 'postMessage is required and must be a function');

      this.postMessage = postMessage;

      if (!this.isReady) {
        this.notify({ event: 'ready' });
        this.isReady = true;
      }
    }
  }, {
    key: 'nextId',
    value: function nextId() {
      var id = this.currentId;
      this.currentId += 1;
      return id;
    }
  }]);

  return WebviewComms;
}();

exports.default = WebviewComms;


//////////////////
// WEBPACK FOOTER
// ./~/@fitbit/webview-comms-lib/lib/webview-comms.js
// module id = 228
// module chunks = 0